// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2pdrP","productName":"Table_productName__2_mMW"};